"use strict";

var _defineProperty = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var bluebird_1 = __importDefault(require("bluebird"));

var SubModule_1 = require("./SubModule");

var procedures_1 = require("../../procedures");

var types_1 = require("../../types");

var PolymathError_1 = require("../../PolymathError");
/**
 * Namespace that handles all Permissions related functionality
 */


var Permissions =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(Permissions, _SubModule_1$SubModul);

  function Permissions() {
    var _this$rolesPerFeature;

    var _this;

    _classCallCheck(this, Permissions);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Permissions).apply(this, arguments));
    /**
     * Get a list of all available roles.
     * The returned roles depend on which features are enabled, as per:
     *
     * | Feature                         | Roles                                           |
     * |---------------------------------|-------------------------------------------------|
     * | Permissions                     | Permissions Administrator                       |
     * | Tokenholders                    | Tokenholders Administrator                      |
     * | Dividends                       | Dividends Administrator, Dividends Operator     |
     * | TokenholderCountRestrictions    | Tokenholder Count Restrictions Administrator    |
     * | PercentageOwnershipRestrictions | Percentage Ownership Restrictions Administrator |
     */

    _this.getAvailableRoles = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _this$securityToken$f, getStatus, list, status, availableRoles;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$securityToken$f = this.securityToken.features, getStatus = _this$securityToken$f.getStatus, list = _this$securityToken$f.list;
                _context.next = 3;
                return getStatus();

              case 3:
                status = _context.sent;

                if (status[types_1.Feature.Permissions]) {
                  _context.next = 6;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FeatureNotEnabled,
                  message: 'You must enable the Permissions feature'
                });

              case 6:
                availableRoles = [];
                list.forEach(function (feature) {
                  if (status[feature]) {
                    availableRoles = [].concat(_toConsumableArray(_this2.rolesPerFeature[feature]), _toConsumableArray(availableRoles));
                  }
                });
                return _context.abrupt("return", availableRoles);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Return whether a certain role is available to be assigned to delegates
     */


    _this.isRoleAvailable = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var role, availableRoles;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                role = args.role;
                _context2.next = 3;
                return this.getAvailableRoles();

              case 3:
                availableRoles = _context2.sent;
                return _context2.abrupt("return", availableRoles.includes(role));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Return which feature is associated with the supplied role
     */


    _this.getFeatureFromRole = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var features, isPermissionsEnabled, role, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                features = this.securityToken.features;
                _context3.next = 3;
                return features.isEnabled({
                  feature: types_1.Feature.Permissions
                });

              case 3:
                isPermissionsEnabled = _context3.sent;

                if (isPermissionsEnabled) {
                  _context3.next = 6;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FeatureNotEnabled,
                  message: 'You must enable the Permissions feature'
                });

              case 6:
                role = args.role;
                lodash_1.forEach(this.rolesPerFeature, function (roles, feature) {
                  if (roles.includes(role)) {
                    result = feature;
                  }
                });
                return _context3.abrupt("return", result);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
    /**
     * Assign a role on the Security Token to a delegate
     *
     * @param args.description - is ignored if the delegate already exists
     */


    _this.assignRole = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.AssignSecurityTokenRole(Object.assign({
                  symbol: symbol,
                  assign: true
                }, args), this.context);
                return _context4.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };
    /**
     * Remove a role from a delegate
     */


    _this.revokeRole = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.AssignSecurityTokenRole(Object.assign({
                  symbol: symbol,
                  assign: false,
                  description: ''
                }, args), this.context);
                return _context5.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    };
    /**
     * Return the list of roles assigned to a delegate address
     */


    _this.getAssignedRoles = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this3 = this;

        var delegate, contractWrappers, _this$securityToken, symbol, features, isPermissionsEnabled, generalPermissionManager, availableRoles, rolesStatus;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                delegate = args.delegateAddress;
                contractWrappers = this.context.contractWrappers, _this$securityToken = this.securityToken, symbol = _this$securityToken.symbol, features = _this$securityToken.features;
                _context7.next = 4;
                return features.isEnabled({
                  feature: types_1.Feature.Permissions
                });

              case 4:
                isPermissionsEnabled = _context7.sent;

                if (isPermissionsEnabled) {
                  _context7.next = 7;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FeatureNotEnabled,
                  message: 'You must enable the Permissions feature'
                });

              case 7:
                _context7.next = 9;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.GeneralPermissionManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 9:
                generalPermissionManager = _context7.sent[0];
                _context7.next = 12;
                return this.getAvailableRoles();

              case 12:
                availableRoles = _context7.sent;
                _context7.next = 15;
                return bluebird_1.default.map(availableRoles, function (role) {
                  return __awaiter(_this3, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee6() {
                    var _ref, moduleName, permission, moduleAddress, status;

                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return contractWrappers.roleToPermission({
                              role: role
                            });

                          case 2:
                            _ref = _context6.sent;
                            moduleName = _ref.moduleName;
                            permission = _ref.permission;
                            _context6.next = 7;
                            return contractWrappers.getModuleAddressesByName({
                              symbol: symbol,
                              moduleName: moduleName
                            }, {
                              unarchived: true
                            });

                          case 7:
                            moduleAddress = _context6.sent[0];
                            _context6.next = 10;
                            return generalPermissionManager.checkPermission({
                              permission: permission,
                              module: moduleAddress,
                              delegate: delegate
                            });

                          case 10:
                            status = _context6.sent;
                            return _context6.abrupt("return", {
                              role: role,
                              status: status
                            });

                          case 12:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));
                });

              case 15:
                rolesStatus = _context7.sent;
                return _context7.abrupt("return", rolesStatus.filter(function (_ref2) {
                  var status = _ref2.status;
                  return status;
                }).map(function (_ref3) {
                  var role = _ref3.role;
                  return role;
                }));

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    };
    /**
     * Return the list of delegate addresses and details that hold a specific role
     */


    _this.getDelegatesForRole = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var _this4 = this;

        var role, contractWrappers, _this$securityToken2, symbol, features, _ref4, _ref5, isPermissionsEnabled, requiredFeature, isFeatureEnabled, generalPermissionManager, _ref6, moduleName, permission, moduleAddress, delegatesWithPerm;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                role = args.role;
                contractWrappers = this.context.contractWrappers, _this$securityToken2 = this.securityToken, symbol = _this$securityToken2.symbol, features = _this$securityToken2.features;
                _context9.next = 4;
                return Promise.all([features.isEnabled({
                  feature: types_1.Feature.Permissions
                }), this.getFeatureFromRole({
                  role: role
                })]);

              case 4:
                _ref4 = _context9.sent;
                _ref5 = _slicedToArray(_ref4, 2);
                isPermissionsEnabled = _ref5[0];
                requiredFeature = _ref5[1];

                if (isPermissionsEnabled) {
                  _context9.next = 10;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FeatureNotEnabled,
                  message: 'You must enable the Permissions feature'
                });

              case 10:
                _context9.next = 12;
                return features.isEnabled({
                  feature: requiredFeature
                });

              case 12:
                isFeatureEnabled = _context9.sent;

                if (isFeatureEnabled) {
                  _context9.next = 15;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FeatureNotEnabled,
                  message: "You must enable the ".concat(requiredFeature, " feature to check delegates for role ").concat(role)
                });

              case 15:
                _context9.next = 17;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.GeneralPermissionManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 17:
                generalPermissionManager = _context9.sent[0];
                _context9.next = 20;
                return contractWrappers.roleToPermission({
                  role: role
                });

              case 20:
                _ref6 = _context9.sent;
                moduleName = _ref6.moduleName;
                permission = _ref6.permission;
                _context9.next = 25;
                return contractWrappers.getModuleAddressesByName({
                  symbol: symbol,
                  moduleName: moduleName
                }, {
                  unarchived: true
                });

              case 25:
                moduleAddress = _context9.sent[0];
                _context9.next = 28;
                return generalPermissionManager.getAllDelegatesWithPerm({
                  module: moduleAddress,
                  perm: permission
                });

              case 28:
                delegatesWithPerm = _context9.sent;
                return _context9.abrupt("return", bluebird_1.default.map(delegatesWithPerm, function (delegateAddress) {
                  return __awaiter(_this4, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee8() {
                    var description;
                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _context8.next = 2;
                            return generalPermissionManager.delegateDetails({
                              delegate: delegateAddress
                            });

                          case 2:
                            description = _context8.sent;
                            return _context8.abrupt("return", {
                              address: delegateAddress,
                              description: description
                            });

                          case 4:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));
                }));

              case 30:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    };
    /**
     * Return a list of all delegates with their respective details and roles
     */


    _this.getAllDelegates = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var _this5 = this;

        var contractWrappers, _this$securityToken3, symbol, features, isPermissionsEnabled, generalPermissionManager, delegates;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                contractWrappers = this.context.contractWrappers, _this$securityToken3 = this.securityToken, symbol = _this$securityToken3.symbol, features = _this$securityToken3.features;
                _context11.next = 3;
                return features.isEnabled({
                  feature: types_1.Feature.Permissions
                });

              case 3:
                isPermissionsEnabled = _context11.sent;

                if (isPermissionsEnabled) {
                  _context11.next = 6;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FeatureNotEnabled,
                  message: 'You must enable the Permissions feature'
                });

              case 6:
                _context11.next = 8;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.GeneralPermissionManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 8:
                generalPermissionManager = _context11.sent[0];
                _context11.next = 11;
                return generalPermissionManager.getAllDelegates();

              case 11:
                delegates = _context11.sent;
                return _context11.abrupt("return", bluebird_1.default.map(delegates, function (delegateAddress) {
                  return __awaiter(_this5, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee10() {
                    var _ref7, _ref8, roles, description;

                    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _context10.next = 2;
                            return Promise.all([this.getAssignedRoles({
                              delegateAddress: delegateAddress
                            }), generalPermissionManager.delegateDetails({
                              delegate: delegateAddress
                            })]);

                          case 2:
                            _ref7 = _context10.sent;
                            _ref8 = _slicedToArray(_ref7, 2);
                            roles = _ref8[0];
                            description = _ref8[1];
                            return _context10.abrupt("return", {
                              address: delegateAddress,
                              roles: roles,
                              description: description
                            });

                          case 7:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10, this);
                  }));
                }));

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    };

    _this.rolesPerFeature = (_this$rolesPerFeature = {}, _defineProperty(_this$rolesPerFeature, types_1.Feature.Permissions, [types_1.SecurityTokenRole.PermissionsAdministrator]), _defineProperty(_this$rolesPerFeature, types_1.Feature.Tokenholders, [types_1.SecurityTokenRole.TokenholdersAdministrator]), _defineProperty(_this$rolesPerFeature, types_1.Feature.Dividends, [types_1.SecurityTokenRole.DividendsAdministrator, types_1.SecurityTokenRole.DividendsOperator]), _defineProperty(_this$rolesPerFeature, types_1.Feature.TokenholderCountRestrictions, [types_1.SecurityTokenRole.TokenholderCountRestrictionsAdministrator]), _defineProperty(_this$rolesPerFeature, types_1.Feature.PercentageOwnershipRestrictions, [types_1.SecurityTokenRole.PercentageOwnershipRestrictionsAdministrator]), _this$rolesPerFeature);
    return _this;
  }

  return Permissions;
}(SubModule_1.SubModule);

exports.Permissions = Permissions;